module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-00.2@2x.9b6051e4.jpg";